var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container pt-2" }, [
        !_vm.showDelegateForm
          ? _c("div", { staticClass: "row justify-content-center text-left" }, [
              _vm._m(0)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row " }, [
          !_vm.showDelegateForm
            ? _c("section", { attrs: { id: "tabs" } }, [
                _c("div", { staticClass: "container" }, [
                  _c("h5", { staticClass: "section-title h3" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row pt-0" }, [
                    _c("div", { staticClass: "col-12 col-md-12" }, [
                      _c("nav", [
                        _c(
                          "div",
                          {
                            staticClass: "nav nav-tabs nav-fill",
                            attrs: { id: "nav-tab", role: "tablist" }
                          },
                          [
                            _c(
                              "a",
                              {
                                class:
                                  "nav-item nav-link  cblack customNItem " +
                                  _vm.section1,
                                attrs: {
                                  id: "nav-home-tab",
                                  "data-toggle": "tab",
                                  href: "#nav-home",
                                  role: "tab",
                                  "aria-controls": "nav-to-do",
                                  "aria-selected": "true"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.setSection(1)
                                  }
                                }
                              },
                              [_vm._v("Pratiche in attesa di Cessione ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                class:
                                  "nav-item nav-link  cblack customNItem " +
                                  _vm.section2,
                                attrs: {
                                  id: "nav-poste-tab",
                                  "data-toggle": "tab",
                                  href: "#nav-poste",
                                  role: "tab",
                                  "aria-controls": "nav-in-work",
                                  "aria-selected": "false"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.setSection(2)
                                  }
                                }
                              },
                              [_vm._v("Cessioni in corso ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                class:
                                  "nav-item nav-link  cblack customNItem " +
                                  _vm.section3,
                                attrs: {
                                  id: "nav-cdp-docs-tab",
                                  "data-toggle": "tab",
                                  href: "#nav-cdp-docs",
                                  role: "tab",
                                  "aria-controls": "nav-ended",
                                  "aria-selected": "false"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.setSection(3)
                                  }
                                }
                              },
                              [_vm._v("Cessioni completate")]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "tab-content  pt-0 mt-0 p-0 vaillantCont",
                          attrs: { id: "nav-tabContent" }
                        },
                        [
                          _c(
                            "div",
                            {
                              class: "pt-0 mt-0 tab-pane fade " + _vm.section11,
                              attrs: {
                                id: "nav-to-do",
                                role: "tabpanel",
                                "aria-labelledby": "nav-home-tab"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 center mb-3 center boxNt"
                                },
                                [
                                  _vm.section1 == " active"
                                    ? _c("practicesToDo")
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: "tab-pane fade " + _vm.section22,
                              attrs: {
                                id: "nav-poste",
                                role: "tabpanel",
                                "aria-labelledby": "nav-in-work"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 center mb-3 center boxNt"
                                },
                                [
                                  _vm.section2 == " active"
                                    ? _c("practicesinWork")
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: "tab-pane fade " + _vm.section33,
                              attrs: {
                                id: "nav-cdp-docs",
                                role: "nav-ended",
                                "aria-labelledby": "nav-cdp-docs-tab"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 center mb-3 center boxNt"
                                },
                                [
                                  _vm.section3 == " active"
                                    ? _c("practicesFinished")
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showDelegateForm
            ? _c(
                "div",
                { staticClass: "row justify-content-center text-left" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "pb-0 mb-0 Bold mb-5" }, [
                    _vm._v(
                      "Prima di procedere con cessioni abbiamo bisogno del tuo consenso  "
                    )
                  ]),
                  _vm._v(" "),
                  _c("delegaForm")
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-12" }, [
      _c("h3", { staticClass: "Regular text-left  h0 widthFull" }, [
        _c("b", [_vm._v("Gestione Cessioni ")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "pb-0 mb-0 text-left Bold" }, [
        _vm._v(
          "In questa sezione puoi gestire le cessioni delle tue Pratiche approvate e validate dopo il 04 ottobre 2021  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "Regular center h0 widthFull" }, [
      _c("b", [_vm._v("Delega intermediario")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1f74d14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f74d14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/index.vue
// module id = null
// module chunks = 